module.exports = __webpack_public_path__ + "assets/images/markers-soft.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/lib/leaflet-awesome-marker/images/markers-soft.png
// module id = 1530
// module chunks = 1